module.exports = __webpack_public_path__ + "img/preview-2.f97b96be.png";